import {
  Stack,
  Switch,
  FormControlLabel,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";
import { useState } from "react";
import { AccessEnums } from "../../constants/accessEnum";
import { useCanAccess } from "../../hooks/canAccess";
import VoiceBroadcastReport from "../../components/panel/report/VoiceBroadcastReport";
import ReloadButton from "../../components/common/reload-button/ReloadButton";
import PbxServerStatusCardWrapper from "../../components/panel/report/PbxServerStatusCardWrapper";

const ReportPage = () => {
  const [autoUpdate, setAutoUpdate] = useState(false);
  const [intervalSec, setIntervalSec] = useState(5);

  const [reload, setReload] = useState(false);
  const { can } = useCanAccess();
  const handleReload = () => {
    setReload(true);
    setTimeout(() => {
      setReload(false);
    }, 100);
  };
  return (
    <Stack width={"100%"} p={3} spacing={2}>
      <Stack
        gap={2}
        height={"45px"}
        display={"flex"}
        alignItems={"center"}
        flexDirection={"row"}
        justifyContent={"end"}
      >
        <ReloadButton reloadAction={handleReload} />
        {autoUpdate && (
          <Select
            size="small"
            sx={{ width: 80 }}
            value={intervalSec}
            onChange={(e) => setIntervalSec(Number(e.target.value))}
          >
            <MenuItem value={5}>5s</MenuItem>
            <MenuItem value={10}>10s</MenuItem>
            <MenuItem value={15}>15s</MenuItem>
          </Select>
        )}
        <FormControlLabel
          control={
            <Switch
              color="primary"
              checked={autoUpdate}
              onChange={(e) => setAutoUpdate(e.target.checked)}
            />
          }
          label="بروزرسانی خودکار"
          sx={{
            margin: 0,
            "& .MuiFormControlLabel-label": {
              margin: 0,
            },
          }}
        />
      </Stack>
      <Grid container spacing={2}>
        {/* <Grid item xs={12} lg={6}>
          {can(AccessEnums.AdminReportsCallQueueSender) && (
            <CallQueueReport
              forceReload={reload}
              refreshInterval={autoUpdate ? intervalSec : undefined}
            />
          )}
        </Grid> */}
        <Grid item xs={12} lg={12}>
          {can(AccessEnums.AdminReportsVoicebroadcastsReport) && (
            <VoiceBroadcastReport
              forceReload={reload}
              refreshInterval={autoUpdate ? intervalSec : undefined}
            />
          )}
        </Grid>
      </Grid>

      {can(AccessEnums.AdminPbxServersList) && (
        <PbxServerStatusCardWrapper
          forceReload={reload}
          refreshInterval={autoUpdate ? intervalSec : undefined}
        />
      )}
    </Stack>
  );
};

export default ReportPage;
